import { render, staticRenderFns } from "./FeedbackUpload.vue?vue&type=template&id=4c501556&scoped=true&"
import script from "./FeedbackUpload.vue?vue&type=script&lang=js&"
export * from "./FeedbackUpload.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackUpload.vue?vue&type=style&index=0&id=4c501556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c501556",
  null
  
)

export default component.exports